module.exports = __webpack_public_path__ + "img/slide-7.3220bc50.jpg";